export enum UserActionRoute {
  Login = 'login',
  Registration = 'registration',
  PendingRegistration = 'pending-registration',
  ChangePassword = 'change-password',
  CompleteRegistrationFromLogin = 'complete-registration-from-login',
  // Adicione outros fluxos conforme necessário
}
